"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;
exports.findAll = findAll;
exports.findType = findType;
exports.remove = remove;
exports.update = update;
var _request = _interopRequireDefault(require("@/utils/request"));
function findAll() {
  return (0, _request.default)({
    url: "/contentDefine"
  });
}
function findType(params) {
  return (0, _request.default)({
    url: "/contentDefine/type",
    params: params
  });
}
function create(data) {
  return (0, _request.default)({
    url: "/contentDefine",
    method: "post",
    data: data
  });
}
function update(id, data) {
  return (0, _request.default)({
    url: "/contentDefine/".concat(id, "/update"),
    method: "post",
    data: data
  });
}
function remove(id) {
  return (0, _request.default)({
    url: "/contentDefine/".concat(id, "/delete"),
    method: "post"
  });
}